// extracted by mini-css-extract-plugin
export default {"success":"index_success_6-K6H","successBox":"index_successBox_jJZTm","successCallback":"index_successCallback_xXmtW"};